import axios from 'axios';

/**
 * 06/2026 Mandanten-Isolation für öffentliche Einbettungs-Seiten.
 *
 * Öffentliche Seiten (buchen, kursplan, preisliste, portal) laufen ohne
 * Login-Token. Ohne Mandanten-Kontext würde das Backend auf den Default-
 * Mandanten (StrongFit) zurückfallen und so Daten verschiedener Mandanten
 * vermischen. Die Einbettungs-Links tragen daher `?tenant=<slug>`; diese
 * Funktion liest den Slug aus der URL und hängt ihn als `x-tenant-slug`
 * Header an alle axios-Requests dieser Seite (vom Tenant-Middleware
 * ausgewertet). Bei eingeloggten Nutzern hat der Token-Claim Vorrang,
 * daher entsteht kein Leak.
 */
export const applyPublicTenant = () => {
  try {
    const slug = new URLSearchParams(window.location.search).get('tenant');
    if (slug && slug.trim()) {
      axios.defaults.headers.common['x-tenant-slug'] = slug.trim();
    }
  } catch (e) {
    /* window nicht verfügbar */
  }
};
